<template>
  <router-link :to="to" class="brand-logo" aria-label="Iberica Blanca — главная">
    <img :src="white ? whiteLogo : colorLogo" alt="Iberica Blanca — comfortable bathroom" />
  </router-link>
</template>

<script>
import colorLogo from '../../assets/images/iberica-logo.svg';
import whiteLogo from '../../assets/images/iberica-logo-white.svg';

export default {
  props: {
    white: Boolean,
    to: { type: String, default: '/' },
  },
  data: () => ({ colorLogo, whiteLogo }),
};
</script>

<style lang="scss">
// The exported SVG viewBox includes the brandbook clear space (page 5).
.brand-logo {
  display: flex;
  align-items: center;
  width: 240px;
  max-width: 100%;
}
.brand-logo img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
